export const ONBOARDING_SUBMIT_ORDER = "ONBOARDING_SUBMIT_ORDER";
export const ONBOARDING_SET_SIM_TYPE = "ONBOARDING_SET_SIM_TYPE";
export const ONBOARDING_SET_SUBSCRIPTION_DETAILS = "ONBOARDING_SET_SUBSCRIPTION_DETAILS";
export const ONBOARDING_VERIFY_UPDATED_NAME = "ONBOARDING_VERIFY_UPDATED_NAME";
